export const constants={
    primaryColor:"#fff",
    secondaryColor:"#11181c",
    tertaryColor:"#003cd6",
    fourthColor:"#ECEDEE"


  }

